import { Box } from "@mui/material";
import { Redirect, Route, RouteProps } from "react-router-dom";
import BuatTokoStep from "../../components/BuatTokoStep/BuatTokoStep";
import Spinner from "../../components/Spinner/Spinner";
import useUser from "../../services/queries/useUser";

interface IBuatTokoPageProps {}

const BuatTokoPage = ({ ...rest }: IBuatTokoPageProps & RouteProps) => {
    const { data: user, status: statusUser } = useUser();

    if (statusUser === "loading") {
        return (
            <Box position="relative" height="100vh">
                <Spinner />
            </Box>
        );
    }

    return (
        <Route
            {...rest}
            render={({ location }) =>
                user?.ukmId.length === 0 ? (
                    <BuatTokoStep />
                ) : (
                    <Redirect
                        to={{
                            pathname:
                                user?.aksesParkir === 1 &&
                                user?.aksesFoodcourt !== 1
                                    ? "/sewa"
                                    : user?.aksesCowork === 1 
                                    ? "/coworking"
                                    : user?.aksesTransaksi === 0 &&
                                      user.aksesStok === 0
                                    ? "/laporan"
                                    : user?.aksesTransaksi === 0 &&
                                      user.aksesLaporan === 0
                                    ? "/stok"
                                    : user?.aksesTransaksi === 0
                                    ? "/stok"
                                    : "/transaksi",
                            state: { from: location },
                        }}
                    />
                )
            }
        />
    );
};

export default BuatTokoPage;
